<template>
  <Message class="message-error" dashboardRedirectLink>
    <img class="message-error_icon" slot="icon" src="./icon_ooops.svg" alt="$t('Упс')" />
    <template slot="message">
      <h1 class="message-error_heading">{{$t('Упс, что-то пошло не так ...')}}</h1>
      <template v-if="errorCode">
        <span class="message-error_code">{{$t('Ошибка') + ' ' + errorCode }}</span>
        <span class="message-error_text">{{$t(ERROR_CODES_MESSAGES[errorCode])}}</span>
      </template>
    </template>
  </Message>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import Message from './Message'
import { ERROR_CODES_MESSAGES } from '@/constants'

@Component({
  components: { Message }
})
class ErrorMessage extends Vue {
  @Prop(String) errorCode

  ERROR_CODES_MESSAGES = ERROR_CODES_MESSAGES
}

export default ErrorMessage

</script>

<style lang="scss">
.message-error {
  &_icon {
    height: 120px;
    width: 120px;
    margin: 34px 0;
    @include media_tablet {
      height: 150px;
      width: 150px;
      margin: 72px 0;
    }
  }
  &_heading {
    font-size: 16px;
    @include media_tablet {
      font-size: 24px;
    }
  }
  &_code {
    font-size: 16px;
    @include media_tablet {
      font-size: 24px;
    }
  }
  &_text {
    font-size: 15px;
    @include media_tablet {
      font-size: 20px;
    }
  }
}
</style>
